import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateStructureType = ({
  denominationId,
  structureTypeId,
  structureTypeData
}) => {
  return axios.put(
    `/denominations/${denominationId}/structure-types/${structureTypeId}`,
    structureTypeData
  );
};

export const useUpdateStructureType = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["structure-types"]);
      queryClient.invalidateQueries(["structure-types-paginated"]);

      setNotification({
        type: "success",
        message: "Structure type updated successfully!"
      });
    },
    ...config,
    mutationFn: updateStructureType
  });
};
